import restaurant from "@/apis/restaurant"
import { restaurantsTypes } from "@/store/mutationTypes";

export default {
    namespaced: true,
    state: {
        concepts: [],
        kitchens: [],
        platforms: [],
        countries: [],
        locations: [],
        fetchAllConcepts: {
            pending: false,
            error: null,
        },
        fetchAllKitchens: {
            pending: false,
            error: null,
        },
        fetchAllPlatforms: {
            pending: false,
            error: null,
        },
        fetchAllCountries: {
            pending: false,
            error: null,
        },
        fetchAllLocations: {
            pending: false,
            error: null,
        },
    },
    mutations: {
        [restaurantsTypes.FETCH_ALL_CONCEPTS_REQUEST]: function (state) {
            state.fetchAllConcepts.pending = true
            state.fetchAllConcepts.error = null
        },
        [restaurantsTypes.FETCH_ALL_CONCEPTS_SUCCESS]: function (state, concepts) {
            state.fetchAllConcepts.error = null
            state.fetchAllConcepts.pending = false
            state.concepts = concepts
        },
        [restaurantsTypes.FETCH_ALL_CONCEPTS_FAILURE]: function (state, error) {
            state.fetchAllConcepts.error = error
            state.fetchAllConcepts.pending = false
        },
        [restaurantsTypes.FETCH_ALL_KITCHENS_REQUEST]: function (state) {
            state.fetchAllKitchens.pending = true
            state.fetchAllKitchens.error = null
        },
        [restaurantsTypes.FETCH_ALL_KITCHENS_SUCCESS]: function (state, kitchens) {
            state.fetchAllKitchens.error = null
            state.fetchAllKitchens.pending = false
            state.kitchens = kitchens
        },
        [restaurantsTypes.FETCH_ALL_KITCHENS_FAILURE]: function (state, error) {
            state.fetchAllKitchens.error = error
            state.fetchAllKitchens.pending = false
        },
        [restaurantsTypes.FETCH_ALL_PLATFORMS_REQUEST]: function (state) {
            state.fetchAllPlatforms.pending = true
            state.fetchAllPlatforms.error = null
        },
        [restaurantsTypes.FETCH_ALL_PLATFORMS_SUCCESS]: function (state, platforms) {
            state.fetchAllPlatforms.error = null
            state.fetchAllPlatforms.pending = false
            state.platforms = platforms
        },
        [restaurantsTypes.FETCH_ALL_PLATFORMS_FAILURE]: function (state, error) {
            state.fetchAllPlatforms.error = error
            state.fetchAllPlatforms.pending = false
        },
        [restaurantsTypes.FETCH_ALL_COUNTRIES_REQUEST]: function (state) {
            state.fetchAllCountries.pending = true
            state.fetchAllCountries.error = null
        },
        [restaurantsTypes.FETCH_ALL_COUNTRIES_SUCCESS]: function (state, countries) {
            state.fetchAllCountries.error = null
            state.fetchAllCountries.pending = false
            state.countries = countries
        },
        [restaurantsTypes.FETCH_ALL_COUNTRIES_FAILURE]: function (state, error) {
            state.fetchAllCountries.error = error
            state.fetchAllCountries.pending = false
        },
        [restaurantsTypes.FETCH_ALL_LOCATIONS_REQUEST]: function (state) {
            state.fetchAllLocations.pending = true
            state.fetchAllLocations.error = null
        },
        [restaurantsTypes.FETCH_ALL_LOCATIONS_SUCCESS]: function (state, locations) {
            state.fetchAllLocations.error = null
            state.fetchAllLocations.pending = false
            state.locations = locations
        },
        [restaurantsTypes.FETCH_ALL_LOCATIONS_FAILURE]: function (state, error) {
            state.fetchAllLocations.error = error
            state.fetchAllLocations.pending = false
        },
    },
    actions: {
        async fetchAllConcepts({ commit }) {
            commit(restaurantsTypes.FETCH_ALL_CONCEPTS_REQUEST)
            return new Promise((resolve, reject) => {
                restaurant
                    .fetchAllConcepts()
                    .then(({ data }) => {
                        commit(restaurantsTypes.FETCH_ALL_CONCEPTS_SUCCESS, data)
                        resolve(data)
                    })
                    .catch((error) => {
                        commit(restaurantsTypes.FETCH_ALL_CONCEPTS_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async fetchAllKitchens({ commit }) {
            commit(restaurantsTypes.FETCH_ALL_KITCHENS_REQUEST)
            return new Promise((resolve, reject) => {
                restaurant
                    .fetchAllKitchens()
                    .then(({ data }) => {
                        commit(restaurantsTypes.FETCH_ALL_KITCHENS_SUCCESS, data)
                        resolve(data)
                    })
                    .catch((error) => {
                        commit(restaurantsTypes.FETCH_ALL_KITCHENS_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async fetchAllPlatforms({ commit }) {
            commit(restaurantsTypes.FETCH_ALL_PLATFORMS_REQUEST)
            return new Promise((resolve, reject) => {
                restaurant
                    .fetchAllPlatforms()
                    .then(({ data }) => {
                        commit(restaurantsTypes.FETCH_ALL_PLATFORMS_SUCCESS, data)
                        resolve(data)
                    })
                    .catch((error) => {
                        commit(restaurantsTypes.FETCH_ALL_PLATFORMS_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async fetchAllCountries({ commit }) {
            commit(restaurantsTypes.FETCH_ALL_COUNTRIES_REQUEST)
            return new Promise((resolve, reject) => {
                restaurant
                    .fetchAllCountries()
                    .then(({ data }) => {
                        commit(restaurantsTypes.FETCH_ALL_COUNTRIES_SUCCESS, data)
                        resolve(data)
                    })
                    .catch((error) => {
                        commit(restaurantsTypes.FETCH_ALL_COUNTRIES_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async fetchAllLocations({ commit }) {
            commit(restaurantsTypes.FETCH_ALL_LOCATIONS_REQUEST)
            return new Promise((resolve, reject) => {
                restaurant
                    .fetchAllLocations()
                    .then(({ data }) => {
                        commit(restaurantsTypes.FETCH_ALL_LOCATIONS_SUCCESS, data)
                        resolve(data)
                    })
                    .catch((error) => {
                        commit(restaurantsTypes.FETCH_ALL_LOCATIONS_FAILURE, error)
                        reject(error)
                    })
            })
        },
    }
}
